import React from 'react';
import { Switch, Route, useHistory, useRouteMatch } from 'react-router-dom';
import { TabPage } from '../../components/tabs';
import { MappableDocumentFields } from '../../views';
import { BoxContainer } from '../../components';
import { usePolicyDocuments } from './hooks';
import { BulkEmail, UploadUpdate } from './containers';
import { DocumentsTable } from './components';
import { BulkDownloadDocuments } from '../bulkDownloadDocuments';
import PolicyDocumentActionsDropdown from './components/PolicyDocumentActionsDropdown';
import useListDocumentRelationshipIds from '../bulkDownloadDocuments/hooks/useListDocumentRelationshipIds';

export const DOCUMENT_TYPE = {
  GENERAL: 'GENERAL',
  APPLICATION: 'APPLICATION',
  CERTIFICATE_OF_INSURANCE: 'CERTIFICATE_OF_INSURANCE'
};

export default function PolicyDocuments({ policy }) {
  const { path, url } = useRouteMatch();
  const history = useHistory();

  const { documents, loading, error } = usePolicyDocuments({ policyId: policy?.id });
  const {
    initialState,
    loading: stateLoading,
    error: stateError
  } = useListDocumentRelationshipIds({ policyId: policy?.id, documents });

  return (
    <Switch>
      <Route exact path={path}>
        <TabPage
          title="Documents"
          buttons={<PolicyDocumentActionsDropdown policy={policy} bulkLoading={stateLoading} bulkError={stateError} />}
        >
          <BoxContainer className="mb-3">
            <DocumentsTable policy={policy} documents={documents} loading={loading} error={error} />
          </BoxContainer>
        </TabPage>
      </Route>

      <Route path={`${path}/mappable-fields`}>
        <MappableDocumentFields policyId={policy?.id} onBack={() => history.push(`${url}`)} />
      </Route>

      <Route path={`${path}/bulk-download`}>
        <BulkDownloadDocuments
          policyId={policy?.id}
          initialState={initialState}
          redirectUrl={`/policies/${policy?.id}/documents`}
        />
      </Route>

      <Route path={`${path}/email`}>
        <BulkEmail
          policyId={policy?.id}
          initialState={initialState}
          redirectUrl={`/policies/${policy?.id}/documents`}
        />
      </Route>

      <Route path={`${path}/upload`}>
        <UploadUpdate policyId={policy?.id} />
      </Route>

      <Route path={`${path}/:documentId/update`}>
        <UploadUpdate policyId={policy?.id} documents={documents} />
      </Route>
    </Switch>
  );
}
